import debounce from 'lodash.debounce';
import { useEffect } from 'react';
/**
 * Runs a debounced function on window resize.
 * @param {() => void} func Function to debounce
 * @param {number | undefined} wait Time to wait
 * @param {import("lodash").DebounceSettings | undefined} options Debounce settings
 */
const useOnResize = (func, wait = 250, options = { trailing: true }) => {
  useEffect(() => {
    const debouncedFunc = debounce(func, wait, options);

    window.addEventListener('resize', debouncedFunc);

    return () => {
      window.removeEventListener('resize', debouncedFunc);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useOnResize;
